import styled from 'styled-components'
import { colors } from '../../../colors'

interface CHIP_PROPS {
  anim?: boolean
}
interface SWIPER_PROPS {
  state: boolean
}

export const SwiperContainer = styled.div<SWIPER_PROPS>`
  position: relative;
  width: 100%;
  height: 70px;
  margin: 14px 0 0;
  pointer-events: ${({ state }) => (state ? 'none' : 'auto')};
  opacity: ${({ state }) => (state ? 0.5 : 1)};

  .swiper-wrapper {
    display: flex;
    align-items: center;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    div {
      pointer-events: none;
    }
  }
`

export const Chip = styled.div<CHIP_PROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${colors.primaryDark};
  border: solid 2px #ffb000;
  transform: ${({ anim }) =>
    anim ? 'scale3d(0.65, 0.65, 0.65) ' : 'scale3d(1,1,1)'};
  transition: transform 167ms;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 50%;
    border: 2px solid ${colors.secondary};
    width: 44px;
    height: 44px;
    color: ${colors.secondary};
    font-size: 9px;
  }
`

export const ChipHolder = styled.div`
  position: absolute;
  border: 3px solid ${colors.primaryDark};
  height: 64px;
  width: 64px;
  border-radius: 50%;
  right: 50%;
  transform: translateX(50%);
  z-index: 2;
  pointer-events: none;
`
